import React, { FC } from 'react';
import { ConstructionAlert } from '../components/ConstructionAlert';

export const TimesPage: FC = () => {
  return (
    <>
      <ConstructionAlert />
      <h2>Times Page</h2>
    </>
  );
};
